import React from 'react';

import { useUpload } from 'hooks/useUpload';

import { Upload } from 'components/shared/Upload';

const UploadField = ({
  multiple,
  isCourseRequest,
  isLessonRequest,
  field,
  requestParams,
  helpers,
  onUploaded,
  ...restProps
}: {
  multiple: any;
  isCourseRequest: any;
  isLessonRequest?: any;
  field: any;
  requestParams: any;
  helpers: any;
  onUploaded: any;
} & Record<string, any>) => {
  const [
    removeLoading,
    percentage,
    onFileDialogOpen,
    onDropAccepted,
    onDropRejected,
    onRemoveClick,
  ] = useUpload({
    multiple,
    isCourseRequest,
    isLessonRequest,
    requestParams,
    value: field.value,
    helpers,
    onUploaded,
  });

  return (
    <Upload
      {...restProps}
      removeLoading={removeLoading}
      name={field.name}
      value={field.value}
      percentage={percentage}
      onFileDialogOpen={onFileDialogOpen}
      onDropAccepted={onDropAccepted}
      onDropRejected={onDropRejected}
      onRemoveClick={onRemoveClick}
    />
  );
};

export default React.memo(UploadField) as any;
